/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

import { Module, Node, format } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';

import {
    // IRefineItemToggleNotification,
    ISearchResultModalViewProps
} from '@msdyn365-commerce-modules/search-result-container/src/modules/search-result-container/./components';
import {
    ICategoryHierarchyViewProps,
    IRefineMenuViewProps,
    ISearchResultContainerViewProps,
    ISortByViewProps,
    ITitleViewProps
} from '@msdyn365-commerce-modules/search-result-container/src/modules/search-result-container/./search-result-container';
import styled from 'styled-components';
// @ts-ignore
import { Warn } from '@churchofjesuschrist/eden-alert';
// // @ts-ignore
// import { A11y } from '@churchofjesuschrist/eden-buttons';

const SearchResultContainerView: React.FC<ISearchResultContainerViewProps> = props => {
    const USE_VIEW_RESTRICTIONS = process.env.USE_VIEW_RESTRICTIONS;
    React.useEffect(() => {
        if (
            parseInt(USE_VIEW_RESTRICTIONS || '', 10) === 1 &&
            props.context.request.user.isAuthenticated === false &&
            props.context.request.user.signInUrl &&
            props.data.category.result &&
            (props.data.category.result.RecordId === 5637160352 ||
                props.data.category.result.RecordId === 5637160344 ||
                props.data.category.result.RecordId === 5637160351 ||
                props.data.category.result.RecordId === 5637175327 ||
                props.data.category.result.RecordId === 5637160430 ||
                props.data.category.result.RecordId === 5637160428 ||
                props.data.category.result.RecordId === 5637160433 ||
                props.data.category.result.RecordId === 5637160343)
        ) {
            window.location.href = props.context.request.user.signInUrl;
        }
    }, []);
    const {
        SearchResultContainer,
        products,
        pagination,
        ProductsContainer,
        ProductSectionContainer,
        choiceSummary,
        isMobile,
        modalToggle,
        searchResultModal,
        TitleViewProps,
        refineMenu,
        categoryHierarchy,
        sortByOptions,
        CategoryNavContainer,
        RefineAndProductSectionContainer,
        errorMessage,
        FeatureSearchContainer,
        similarLookProduct,
        resources
    } = props;
    React.useEffect(() => {
        let productCategories =
            categoryHierarchy && categoryHierarchy.categoryHierarchyList
                ? categoryHierarchy.categoryHierarchyList.map((category: any) => {
                      return category.props.text;
                  })
                : '';
        //@ts-ignore
        sessionStorage.setItem('ProductCategory', productCategories);
        if (
            props.data &&
            props.data.products &&
            props.data.products.result &&
            props.context.request.query &&
            props.context.request.query.q
        ) {
            const { request } = props.context;
            // @ts-ignore
            if (window && window['digitalData']) {
                // @ts-ignore
                window['digitalData'].push({
                    event: 'Search',
                    search: {
                        info: {
                            term: request.query && request.query.q ? request.query.q : '',
                            results: props.data.products.result.count
                        },
                        category: {
                            primary: 'keyword'
                        }
                    }
                });
            }
        } else if (props.context && props.context.request && props.context.request.query && props.context.request.query.q) {
            const { request } = props.context;
            // @ts-ignore
            if (window && window['digitalData']) {
                // @ts-ignore
                window['digitalData'].push({
                    event: 'Search',
                    search: {
                        info: {
                            term: request.query && request.query.q ? request.query.q : '',
                            results: 0
                        },
                        category: {
                            primary: 'keyword'
                        }
                    }
                });
            }
        }

        const sizingChartCheck = sessionStorage.getItem('sizingChart');

        if (sizingChartCheck && sizingChartCheck === 'true') {
            sessionStorage.setItem('sizingChart', 'false');
        }
    }, []);
    // @ts-ignore
    const isRecoSearchPage = props.context.actionContext.requestContext.query?.recommendation;
    let categoryType = props.data.category && props.data.category.result ? props.data.category.result.Name : '';
    // @ts-ignore
    const errorText = format(props.resources.notAuthenticatedSearchErrorInsert, categoryType);
    let isProducts;
    // @ts-ignore
    if (products && products.props) {
        // @ts-ignore
        isProducts = products.props.products[0] ? true : false;
    }
    // Create a filtered version of choiceSummary if needed
    let filteredChoiceSummary = choiceSummary;
    // @ts-ignore
    if (choiceSummary && choiceSummary.props && choiceSummary.props.selectedChoices) {
        const hiddenFilters = ['temple_no', 'endowment_no', 'recommend_no'];
        // @ts-ignore
        const filteredChoices = choiceSummary.props.selectedChoices.filter((choice: any) => {
            return !hiddenFilters.includes(choice.LeftValueBoundString.toLowerCase() || choice.RightValueBoundString.toLowerCase());
        });

        // Create a new component with filtered choices
        // @ts-ignore
        if (filteredChoices.length !== choiceSummary.props.selectedChoices.length) {
            // @ts-ignore
            filteredChoiceSummary = React.cloneElement(choiceSummary, {
                // @ts-ignore
                ...choiceSummary.props,
                selectedChoices: filteredChoices
            });
        }
    }
    if (isMobile) {
        return (
            <Module {...SearchResultContainer}>
                {/* {renderCategoryHierarchy(categoryHierarchy)} */}
                {renderTitle(TitleViewProps)}
                {filteredChoiceSummary}
                {modalToggle}
                {createSearchResultModal(
                    searchResultModal,
                    refineMenu,
                    sortByOptions,
                    isRecoSearchPage,
                    isProducts,
                    resources,
                    props.context,
                    props.data.listPageState,
                    isMobile
                )}
                <Node {...FeatureSearchContainer}>{similarLookProduct}</Node>
                <Node {...ProductsContainer}>
                    {/* @ts-ignore */}
                    {!props.context.request.user.isAuthenticated && errorMessage !== '' ? (
                        <Warn>
                            <div style={{ paddingTop: '3px' }}>
                                {/* @ts-ignore */}
                                {props.resources.notAuthenticatedErrorOne} {/* @ts-ignore */}
                                <a href={props.context.request.user.signInUrl}>{props.resources.signInLinkTextAlt} </a>
                                {categoryType
                                    ? errorText
                                    : /* @ts-ignore */
                                      props.resources.notAuthenticatedSearchErrorTwo}
                            </div>
                        </Warn>
                    ) : (
                        errorMessage
                    )}
                    {products}
                </Node>
                {pagination}
            </Module>
        );
    }

    let filteredProducts: any;
    let newList;

    // @ts-ignore
    if (products && products.props && products.props.products && props.config.filterProducts) {
        // Get current country from sessionStorage only if in browser environment
        let currentCountry = '';
        if (typeof window !== 'undefined' && window.sessionStorage) {
            currentCountry = sessionStorage.getItem('country') || '';
        }

        // @ts-ignore
        newList = products.props.products.filter((product: any) => {
            // Check if this product should be filtered out
            // @ts-ignore
            const shouldFilter = props.config.filterProducts.some((filter: any) => {
                // Check if product ID matches
                if (filter.productId !== product.ItemId) {
                    return false;
                }

                // If countryList is empty, apply filter regardless of country
                if (!filter.countryList || filter.countryList.length === 0) {
                    return true;
                }

                // If countryList has countries, only apply if current country matches
                return filter.countryList.includes(currentCountry);
            });

            // Return true to keep the product (filter out if shouldFilter is true)
            return !shouldFilter;
        });
    }

    if (newList && products) {
        // @ts-ignore
        filteredProducts = React.cloneElement(products, {
            // @ts-ignore
            ...products.props,
            products: newList
        });
    }

    return (
        <Module {...SearchResultContainer}>
            {categoryHierarchy && renderCategoryHierarchy(categoryHierarchy)}
            {sortByOptions && !isRecoSearchPage && renderSort(sortByOptions)}
            <Node {...CategoryNavContainer}>{TitleViewProps && renderTitleCount(TitleViewProps)}</Node>
            <Node {...RefineAndProductSectionContainer}>
                {refineMenu &&
                    renderRefiner(refineMenu, isProducts, resources, props.context, props.data.listPageState, isMobile, props.refineMenu)}
                <Node {...ProductSectionContainer}>
                    {TitleViewProps && renderTitle(TitleViewProps)}
                    {filteredChoiceSummary}
                    <Node {...FeatureSearchContainer}>{similarLookProduct}</Node>
                    <Node {...ProductsContainer}>
                        {/* @ts-ignore */}
                        {!props.context.request.user.isAuthenticated && errorMessage !== '' ? (
                            <Warn>
                                <div style={{ paddingTop: '3px' }}>
                                    {/* @ts-ignore */}
                                    {props.resources.notAuthenticatedErrorOne} {/* @ts-ignore */}
                                    <a href={props.context.request.user.signInUrl}>{props.resources.signInLinkTextAlt} </a>
                                    {categoryType
                                        ? errorText
                                        : /* @ts-ignore */
                                          props.resources.notAuthenticatedSearchErrorTwo}
                                </div>
                            </Warn>
                        ) : (
                            errorMessage
                        )}
                        {/* {products}
                        {filteredProducts} */}
                        {filteredProducts || products}
                    </Node>
                    {pagination}
                </Node>
            </Node>
        </Module>
    );
};

const createSearchResultModal = (
    modalProps: ISearchResultModalViewProps,
    refineMenu: IRefineMenuViewProps,
    sortByDropDown: ISortByViewProps,
    isRecoSearchPage?: string,
    isProducts?: any,
    resources?: any,
    context?: any,
    listPageState?: any,
    isMobile?: boolean
): JSX.Element => {
    return React.cloneElement(
        modalProps.modal,
        {},
        modalProps.modalHeader,
        createModalBody(modalProps, refineMenu, sortByDropDown, isRecoSearchPage, isProducts, resources, context, listPageState, isMobile),
        modalProps.modalFooter
    );
};

const createModalBody = (
    props: ISearchResultModalViewProps,
    refineMenu: IRefineMenuViewProps,
    sortByDropDown: ISortByViewProps,
    isRecoSearchPage?: string,
    isProducts?: any,
    resources?: any,
    context?: any,
    listPageState?: any,
    isMobile?: boolean
): JSX.Element | null => {
    // if (sortByDropDown) {
    return React.cloneElement(
        props.modalBody,
        {},
        renderSort(sortByDropDown, isRecoSearchPage),
        renderRefiner(refineMenu, isProducts, resources, context, listPageState, isMobile, refineMenu)
    );
    // }
    // return null;
};

const renderRefiner = (
    props: IRefineMenuViewProps,
    isProducts?: boolean,
    resources?: any,
    context?: any,
    listPageState?: any,
    isMobile?: boolean,
    refineMenu?: any
): JSX.Element | null => {
    const { refiners, RefineMenuContainer, RefinerSectionContainer } = props;
    if (refiners) {
        const filteredRefiners = refiners?.filter(refiner => {
            return (
                // @ts-ignore
                refiner!.props.productRefinerHierarchy.RecordId !== 5637150753 &&
                // @ts-ignore
                refiner!.props.productRefinerHierarchy.RecordId !== 5637150743 &&
                // @ts-ignore
                refiner!.props.productRefinerHierarchy.RecordId !== 5637150607 &&
                // @ts-ignore
                refiner!.props.productRefinerHierarchy.Values &&
                // @ts-ignore
                refiner!.props.productRefinerHierarchy.Values[0].LeftValueBoundString !== 'Not Applicable'
            );
            // return refiner!.key !== '1' && refiner!.key !== '2' && refiner!.key !== '5' && refiner!.key !== '6' && refiner!.key !== '7';
        });
        return (
            <Node {...RefinerSectionContainer}>
                {/* {isMobile && listPageState.result?.activeFilters?.length > 0 && (
                    <ul
                        className='refiner-tags-list'
                        style={{
                            display: 'flex',
                            flexWrap: 'wrap',
                            gap: '0.5rem',
                            listStyle: 'none',
                            padding: 0,
                            margin: 0,
                            width: '100%',
                            marginTop: '10px',
                            marginBottom: '10px'
                        }}
                    >
                        {listPageState.result?.activeFilters?.map((filter: any) => {
                            const hiddenFilters = ['temple_no', 'endowment_no', 'recommend_no'];
                            const filterValue = (filter.LeftValueBoundString || '').toLowerCase();

                            if (hiddenFilters.includes(filterValue)) {
                                return null; // Skip rendering this filter
                            }

                            const mockNotification: IRefineItemToggleNotification = {
                                parentProductRefinerHierarchy: {
                                    Values: [
                                        {
                                            RefinerRecordId: filter.RefinerRecordId,
                                            RefinerSourceValue: filter.RefinerSourceValue,
                                            DataTypeValue: filter.DataTypeValue,
                                            LeftValueBoundString: filter.LeftValueBoundString,
                                            RightValueBoundString: filter.RightValueBoundString,
                                            SwatchImageUrl: filter.SwatchImageUrl,
                                            SwatchColorHexCode: filter.SwatchColorHexCode
                                        }
                                    ]
                                },
                                productRefinerValue: {
                                    RefinerRecordId: filter.RefinerRecordId,
                                    RefinerSourceValue: filter.RefinerSourceValue,
                                    DataTypeValue: filter.DataTypeValue,
                                    LeftValueBoundString: filter.LeftValueBoundString,
                                    RightValueBoundString: filter.RightValueBoundString,
                                    SwatchImageUrl: filter.SwatchImageUrl,
                                    SwatchColorHexCode: filter.SwatchColorHexCode
                                },
                                isSelecting: false,
                                rangeStart: undefined,
                                rangeEnd: undefined
                            };

                            return (
                                <li key={filter.id}>
                                    <button
                                        onClick={() =>
                                            // @ts-ignore
                                            refineMenu.refiners?.[0]?.props.onUpdateRefiners(mockNotification)
                                        }
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            background: '#3a3d40',
                                            borderRadius: '15px',
                                            paddingLeft: '1rem',
                                            paddingRight: '0.5rem',
                                            fontSize: '11px',
                                            fontWeight: 400,
                                            letterSpacing: '0.11px',
                                            color: '#fff',
                                            cursor: 'pointer',
                                            border: 'none',
                                            height: '30px'
                                        }}
                                    >
                                        <span style={{ marginRight: '0.5rem' }}>{filter.LeftValueBoundString || ''}</span>
                                        <span>✕</span>
                                    </button>
                                </li>
                            );
                        })}
                    </ul>
                )} */}
                <Node {...RefineMenuContainer}>
                    {/* {isProducts
                        ? filteredRefiners.map((submenu, index) => {
                              if (
                                  //   @ts-ignore
                                  submenu.props.productRefinerHierarchy.KeyName === 'Category' &&
                                  //   @ts-ignore
                                  submenu.props.context.request.locale === 'zh'
                              ) {
                                  //   @ts-ignore
                                  submenu.props.productRefinerHierarchy.KeyName = resources.categoryRefinerText;
                              }
                              //   return <React.Fragment key={index}>{submenu}</React.Fragment>;
                              return (
                                  <>
                                      <React.Fragment key={index}>{submenu}</React.Fragment>
                                  </>
                              );
                          })
                        : !isProducts && context.request.query.refiners
                        ? filteredRefiners.map((submenu, index) => {
                              if (
                                  //   @ts-ignore
                                  submenu.props.productRefinerHierarchy.KeyName === 'Category' &&
                                  //   @ts-ignore
                                  submenu.props.context.request.locale === 'zh'
                              ) {
                                  //   @ts-ignore
                                  submenu.props.productRefinerHierarchy.KeyName = resources.categoryRefinerText;
                              }
                              //   return <React.Fragment key={index}>{submenu}</React.Fragment>;
                              return (
                                  <>
                                      <React.Fragment key={index}>{submenu}</React.Fragment>
                                  </>
                              );
                          })
                        : null} */}
                    {isProducts
                        ? filteredRefiners.map((submenu, index) => {
                              if (
                                  //   @ts-ignore
                                  submenu.props.productRefinerHierarchy.KeyName === 'Category' &&
                                  //   @ts-ignore
                                  submenu.props.context.request.locale === 'zh'
                              ) {
                                  //   @ts-ignore
                                  submenu.props.productRefinerHierarchy.KeyName = resources.categoryRefinerText;
                              }
                              //   return <React.Fragment key={index}>{submenu}</React.Fragment>;
                              return (
                                  <>
                                      <React.Fragment key={index}>{submenu}</React.Fragment>
                                  </>
                              );
                          })
                        : null}
                </Node>
            </Node>
        );
    }
    return null;
};

const renderSort = (props: ISortByViewProps, isRecoSearchPage?: string): JSX.Element | null => {
    const SortContainer = styled.div`
        display: flex;
        justify-content: flex-end;
    `;
    // const { sortByDropDown } = props;
    if (props && props.sortByDropDown && !isRecoSearchPage) {
        return <SortContainer>{props.sortByDropDown}</SortContainer>;
    }
    return null;
};

const renderCategoryHierarchy = (props: ICategoryHierarchyViewProps): JSX.Element | null => {
    const { CategoryHierarchyContainer, categoryHierarchyList, categoryHierarchySeparator } = props;
    if (categoryHierarchyList) {
        return (
            <Node {...CategoryHierarchyContainer}>
                {categoryHierarchyList.map((category, index) => {
                    let lastCategoryIndex = categoryHierarchyList.length - 1;
                    // @ts-ignore
                    let isLast = category.key === lastCategoryIndex.toString() ? true : false;
                    return (
                        <React.Fragment key={index}>
                            {/* {category} */}
                            <a
                                // @ts-ignore
                                key={category.key}
                                // @ts-ignore
                                href={category.props.href}
                                style={{
                                    color: isLast ? '#212225' : '#157493',
                                    textDecoration: isLast ? 'none' : 'underline'
                                }}
                            >
                                {/* @ts-ignore */}
                                {category.props.text}
                            </a>
                            {categoryHierarchyList && categoryHierarchyList[index + 1] && categoryHierarchySeparator}
                        </React.Fragment>
                    );
                })}
            </Node>
        );
    }

    return null;
};

const renderTitle = (props: ITitleViewProps): JSX.Element | null => {
    const { title, TitleContainer } = props;
    if (title) {
        return (
            <Node {...TitleContainer}>
                <h2>
                    {title.titlePrefix}
                    {title.titleText}
                </h2>
            </Node>
        );
    }
    return null;
};

const renderTitleCount = (props: ITitleViewProps): JSX.Element | null => {
    const { title, TitleContainer } = props;
    if (title) {
        return (
            <Node {...TitleContainer}>
                <h5>{title.titleCount}</h5>
            </Node>
        );
    }
    return null;
};

export default SearchResultContainerView;
